import { addLayerExist, removerLayerExist } from '../layerStatusControl'

const satelliteLayers = {}

/* 添加卫星 */
function addSatelliteLayer (layerInfo, viewer) {
  const id = layerInfo.id
  const position = layerInfo.position
  const lon = position[0] || null
  const lat = position[1] || null
  const radii = layerInfo.radii || 200000.0
  const image = layerInfo.image
  const scale = layerInfo.scale

  const satellite = viewer.entities.add({
    name: id,
    position: Cesium.Cartesian3.fromDegrees(lon, lat, radii),
    billboard: {
      image: image,
      scale: scale
      // default: 1.0
    }
  })
  satelliteLayers[id] = satellite
  const addInfo = {
    info: layerInfo,
    layer: null,
    market: satellite
  }
  addLayerExist(addInfo)
  return true
}

/* 修改卫星位置 */
function setSatelliteLayer (layerInfo, viewer) {
  const _id = layerInfo.id
  if (satelliteLayers[_id]) {
    const satelliteItem = satelliteLayers[_id]
    const position = layerInfo.position
    const lon = position[0] || null
    const lat = position[1] || null
    const radii = layerInfo.radii || 200000.0
    satelliteItem.position = Cesium.Cartesian3.fromDegrees(lon, lat, radii)
  }
}

/* 删除卫星 */
function removeSatelliteLayer (layerInfo, viewer) {
  const _id = layerInfo.id
  if (satelliteLayers[_id]) {
    const satelliteItem = satelliteLayers[_id]
    viewer.entities.remove(satelliteItem)
    removerLayerExist(layerInfo)
  }
}

export { addSatelliteLayer, setSatelliteLayer, removeSatelliteLayer }
